import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { CompareDetail } from '@src/pages/Compare';

export const Route = createLazyFileRoute('/compare/qualys')({
  component: QualysComparePage,
});

function QualysComparePage() {
  return (
    <DefaultLayout>
      <CompareDetail competitorId="qualys" />
    </DefaultLayout>
  );
}
